import React from "react";
import { useNavigate } from 'react-router-dom';
import { LogOut, Menu, X } from 'lucide-react';

function Header({ onMenuToggle, isMobileMenuOpen }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <header className="flex min-h-[60px] items-center justify-between gap-3 border-b border-gray-200 bg-white px-3 shadow-md sm:px-6">
      <div className="flex min-w-0 items-center gap-2">
        <button
          type="button"
          onClick={onMenuToggle}
          aria-label={isMobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
          className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 lg:hidden"
        >
          {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
        <h1 className="truncate text-lg font-bold tracking-tight text-gray-800 sm:text-2xl">
          MEDICARE IPS
        </h1>
      </div>
      <button
        onClick={handleLogout}
        className="flex shrink-0 items-center gap-2 rounded-lg bg-red-500 px-3 py-2 text-white transition-all duration-300 hover:bg-red-600 sm:px-4"
      >
        <LogOut size={18} />
        <span className="hidden sm:inline">Cerrar sesión</span>
      </button>
    </header>
  );
}

export default Header;
